var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlleriesEmptyState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 161,
    viewBox: "0 0 240 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1160_77029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.498 21.8359H80.5326C77.587 21.8359 75.1992 24.2238 75.1992 27.1693V50.8762C75.1992 53.8217 77.587 56.2095 80.5326 56.2095H159.498C162.444 56.2095 164.831 53.8217 164.831 50.8762V27.1693C164.831 24.2238 162.444 21.8359 159.498 21.8359Z",
    fill: "#FDFDFD",
    stroke: "#D9D8DF",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.594 32.3906H102.987C101.872 32.3906 100.969 33.2942 100.969 34.4088C100.969 35.5233 101.872 36.4269 102.987 36.4269H153.594C154.708 36.4269 155.612 35.5233 155.612 34.4088C155.612 33.2942 154.708 32.3906 153.594 32.3906Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.344 41.3906H102.987C101.872 41.3906 100.969 42.2942 100.969 43.4088C100.969 44.5233 101.872 45.4269 102.987 45.4269H134.344C135.459 45.4269 136.362 44.5233 136.362 43.4088C136.362 42.2942 135.459 41.3906 134.344 41.3906Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4037 47.6829C84.6528 47.6829 80.8008 43.7768 80.8008 38.9586C80.8008 34.1408 84.6528 30.2344 89.4037 30.2344C94.1549 30.2344 98.0069 34.1408 98.0069 38.9586C98.0069 43.7768 94.1549 47.6829 89.4037 47.6829Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4335 37.5078L88.7991 41.3854L86.6172 39.0593",
    stroke: "#FDFDFD",
    strokeWidth: 0.951467,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.498 63.2422H80.5326C77.587 63.2422 75.1992 65.63 75.1992 68.5755V92.2825C75.1992 95.228 77.587 97.6158 80.5326 97.6158H159.498C162.444 97.6158 164.831 95.228 164.831 92.2825V68.5755C164.831 65.63 162.444 63.2422 159.498 63.2422Z",
    fill: "#FDFDFD",
    stroke: "#D9D8DF",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.594 73.8047H102.987C101.872 73.8047 100.969 74.7082 100.969 75.8228C100.969 76.9374 101.872 77.841 102.987 77.841H153.594C154.708 77.841 155.612 76.9374 155.612 75.8228C155.612 74.7082 154.708 73.8047 153.594 73.8047Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.344 82.8047H102.987C101.872 82.8047 100.969 83.7082 100.969 84.8228C100.969 85.9374 101.872 86.841 102.987 86.841H134.344C135.459 86.841 136.362 85.9374 136.362 84.8228C136.362 83.7082 135.459 82.8047 134.344 82.8047Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4037 89.097C84.6528 89.097 80.8008 85.1906 80.8008 80.3727C80.8008 75.5546 84.6528 71.6484 89.4037 71.6484C94.1549 71.6484 98.0069 75.5546 98.0069 80.3727C98.0069 85.1906 94.1549 89.097 89.4037 89.097Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4335 78.9219L88.7991 82.7992L86.6172 80.4731",
    stroke: "#FDFDFD",
    strokeWidth: 0.951467,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.498 104.656H80.5326C77.587 104.656 75.1992 107.044 75.1992 109.99V133.697C75.1992 136.642 77.587 139.03 80.5326 139.03H159.498C162.444 139.03 164.831 136.642 164.831 133.697V109.99C164.831 107.044 162.444 104.656 159.498 104.656Z",
    fill: "#FDFDFD",
    stroke: "#D9D8DF",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.594 115.211H102.987C101.872 115.211 100.969 116.114 100.969 117.229C100.969 118.344 101.872 119.247 102.987 119.247H153.594C154.708 119.247 155.612 118.344 155.612 117.229C155.612 116.114 154.708 115.211 153.594 115.211Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.344 124.219H102.987C101.872 124.219 100.969 125.122 100.969 126.237C100.969 127.351 101.872 128.255 102.987 128.255H134.344C135.459 128.255 136.362 127.351 136.362 126.237C136.362 125.122 135.459 124.219 134.344 124.219Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4037 130.511C84.6528 130.511 80.8008 126.605 80.8008 121.787C80.8008 116.969 84.6528 113.062 89.4037 113.062C94.1549 113.062 98.0069 116.969 98.0069 121.787C98.0069 126.605 94.1549 130.511 89.4037 130.511Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4335 120.328L88.7991 124.206L86.6172 121.88",
    stroke: "#FDFDFD",
    strokeWidth: 0.951467,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1160_77029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 160,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlleriesEmptyState);
export default __webpack_public_path__ + "static/media/alleries-empty-state.5144892ed0eac3144851cef09371e4ea.svg";
export { ForwardRef as ReactComponent };